import { ProvinceV2, Ward } from '@/app/shared/interface/province.interface';
import { CommonService } from '@/app/shared/services/common.service';
import { FileService } from '@/app/shared/services/file.service';
import { ProvinceService } from '@/app/shared/services/province.service';
import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-business-registration-certificate',
  templateUrl: './business-registration-certificate.component.html',
  styleUrl: './business-registration-certificate.component.scss'
})
export class BusinessRegistrationCertificateComponent {

  @ViewChild('loadingModal', { static: false }) loadingModal: TemplateRef<string>;
  @ViewChild('confirmModal', { static: false }) confirmModal: TemplateRef<string>;

  select2Provinces: any;
  select2Wards: any;
  @Input() user: any;
  @Input() files: any[] = [];
  @Input() fileType: any;
  loadingWards = false;
  @Output() confirmForm: EventEmitter<any> = new EventEmitter();
  @Output() closeForm: EventEmitter<any> = new EventEmitter();

  public formOfBusinesses = [
    {
      code: 0,
      name: 'Nhà thuốc',
    },
    {
      code: 1,
      name: 'Quầy thuốc',
    },
    {
      code: 2,
      name: 'Tủ thuốc trạm y tế xã',
    },
    {
      code: 3,
      name: 'Cơ sở bán buôn',
    },
    {
      code: 4,
      name: 'Bệnh viện',
    },
    {
      code: 5,
      name: 'Cơ sở khám chữa bệnh khác',
    },
    {
      code: 6,
      name: 'Khác',
    },
  ];

  public selectedBusinessType: number;
  public selectedProvince: number;
  public selectedDistrict: number;
  public selectedWard: number;

  form: FormGroup;

  constructor(
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private fileService: FileService,
    private commonService: CommonService,
    private toastService: ToastrService,
    private provinceService: ProvinceService,
  ) {
    this.form = this.formBuilder.group({
      businessName: new FormControl('', [Validators.required]),
      taxCode: new FormControl('', [Validators.required]),
      province: new FormControl(null, [Validators.required]),
      ward: new FormControl(null, [Validators.required]),
      address: new FormControl(''),
      businessLicensesNo: new FormControl('', [Validators.required]),
      businessLicensesDate: new FormControl('', [Validators.required]),
      businessLicensesProvince: new FormControl(null, [Validators.required]),
      buyerName: new FormControl('', [Validators.required]),
    });
  }
  getProvinceV2Region() {
    if (!this.select2Provinces || !this.select2Provinces.length) {
      this.provinceService.getProvinceV2InfoByRegion().subscribe({
        next: (res: ProvinceV2[]) => {
          this.select2Provinces = (res ?? []).map(
            (province: ProvinceV2) =>
              new Object({
                value: province.code,
                label: province.name,
              })
          );
        },
        error: (err: any) => {
          console.error(err);
        },
      })
    }
  }

  loadWardsByProvince($event: any) {
    if ($event.value && !this.loadingWards && this.selectedProvince != $event.value) {
      this.loadingWards = true;
      this.provinceService.getProvinceV2InfoByDepth($event.value, 0).subscribe({
        next: (res: ProvinceV2[]) => {
          this.select2Wards = res[0].wards.map(
            (ward: Ward) =>
              new Object({
                value: ward.code,
                label: ward.name,
              })
          )
        },
        error: (err: any) => {
          console.error(err);
          this.loadingWards = false;
        },
        complete: () => {
          this.loadingWards = false;
        }
      })
    }
  }

  open() {
    this.form.reset();
    this.getProvinceV2Region();
    let loadingModal = this.modalService.open(this.loadingModal, {
      backdrop: 'static',
      ariaLabelledBy: 'address-add-Modal',
      centered: true,
      size: 'xl',
      windowClass: 'theme-modal modal-login',
    });
    loadingModal.shown.subscribe(() => {
      this.readFiles(this.files);
    });
  }

  openModal() {
    this.modalService.open(this.confirmModal, {
      backdrop: 'static',
      ariaLabelledBy: 'address-add-Modal',
      centered: true,
      size: 'xl',
      windowClass: 'theme-modal modal-login',
    }).result.then(
      (result) => {
        `Result ${result}`;
      },
      (reason) => { }
    );
  }

  readFiles(files: any) {
    this.fileService.uploadTextract(files, this.fileType, this.user.userName).subscribe({
      next: (res: any) => {
        if (res) {
          if (res.ocrResult.confidence_score < 0.9) {
            this.toastService.error('Hình ảnh không rõ nét, vui lòng chọn ảnh khác!', '', { positionClass: 'toast-top-right' });
            // this.onClose();
            return;
          }
          let certificationDate;

          certificationDate = moment(this.commonService.convertVietnameseDateToNumeric(res.ocrResult.business_registration_date)).format('YYYY-MM-DD');

          if (!certificationDate) {
            this.toastService.error('Ngày cấp không hợp lệ!', '', { positionClass: 'toast-top-right' });
          }
          this.form.patchValue({
            businessName: res.ocrResult.business_household_name,
            buyerName: res.ocrResult.business_household_name,
            taxCode: res.ocrResult.tax_code != 'N/A' ? res.ocrResult.tax_code : '',
            // province: res.ocrResult.business_address.province_city,
            // district: res.ocrResult.business_address.district,
            // ward: res.ocrResult.business_address.ward_commune,
            address: res.ocrResult.business_address?.detailed_address,
            businessLicensesNo: res.ocrResult.business_registration_number,
            businessLicensesDate: this.commonService.convertDateToNgbDate(certificationDate || ''),
            businessLicensesProvince: res.ocrResult.issuing_authority,
          });
        }
      },
      error: (err) => {
        console.log(err);
        this.toastService.error('Có lỗi xảy ra, vui lòng thử lại!', '', { positionClass: 'toast-top-right' });
        this.onClose();
      },
      complete: () => {
        this.modalService.dismissAll();
        this.openModal();
      }
    });
  }

  onConfirm() {
    this.confirmForm.emit(this.form.value);
    this.modalService.dismissAll();
  }

  onClose() {
    this.modalService.dismissAll();
    this.closeForm.emit();
  }
}
